import React, { useEffect, useState } from "react";
import { Box, CircularProgress, IconButton } from "@mui/material";
import { primary } from "style/color";
import {
  useCreateGrantVestmentInteractionMutation,
  useGetGrantVestmentInteractionQuery,
  useDeleteGrantVestmentInteractionMutation,
  useDeleteGrantVestmentFollowerMutation,
  useCreateGrantVestmentFollowerMutation,
  useGetGrantVestmentFollowerQuery,
} from "hooks/use-services/grant-vestment.service";
import { User } from "types/user";
import { GrantVestment } from "types/grant-vestment";
import { ReactComponent as ThumbUpIcon } from "./../../../assets/Icons/thumb-up.svg";
import { ReactComponent as ThumbDownIcon } from "./../../../assets/Icons/thumb-down.svg";
import { ReactComponent as NotificationsIcon } from "./../../../assets/Icons/notification.svg";

interface GrantVestmentInteractionsProps {
  grantvestment: GrantVestment;
  user: User;
}

const GrantVestmentInteractions: React.FC<GrantVestmentInteractionsProps> = ({
  grantvestment,
  user,
}) => {
  const [likedState, setLikedState] = useState<boolean | null>(null);
  const [followState, setFollowState] = useState<boolean | null>(null);

  const {
    data: interactionData,
    isSuccess: interactionSuccess,
    isLoading,
  } = useGetGrantVestmentInteractionQuery({
    filter: {
      grantvestmentId: grantvestment.grantVestmentId!,
      userId: user?.userId ?? 0,
    },
  });

  const {
    data: followerData,
    isSuccess: followerSuccess,
    isLoading: followerIsLoading,
  } = useGetGrantVestmentFollowerQuery({
    filter: {
      grantvestmentId: grantvestment.grantVestmentId!,
      userId: user?.userId ?? 0,
    },
  });

  const createGrantVestmentInteractionMutation =
    useCreateGrantVestmentInteractionMutation();

  const createGrantVestmentFollowerMutation =
    useCreateGrantVestmentFollowerMutation();

  const deleteGrantVestmentInteractionMutation =
    useDeleteGrantVestmentInteractionMutation();

  const deleteGrantvestmentFollower = useDeleteGrantVestmentFollowerMutation();

  useEffect(() => {
    if (interactionSuccess && interactionData?.pages[0].data.length > 0) {
      setLikedState(interactionData?.pages[0].data[0].liked);
    }
  }, [interactionSuccess, interactionData]);

  useEffect(() => {
    if (followerSuccess && followerData?.pages[0].data.length > 0) {
      setFollowState(followerData?.pages[0].data.length > 0 ? true : false);
    }
  }, [followerSuccess, followerData]);

  return (
    <>
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress color="primary" size={20} />
        </Box>
      )}

      {interactionSuccess && (
        <>
          {" "}
          <IconButton
            className="grantvenstment"
            onClick={() => {
              if (followState === true) {
                setFollowState(null);
                if (followerData?.pages[0]?.data[0]) {
                  deleteGrantvestmentFollower.mutate(
                    followerData.pages[0].data[0].grantVestmentFollowerId
                  );
                }
              } else {
                setFollowState(true);
                createGrantVestmentFollowerMutation.mutate({
                  sub: user?.sub as string,
                  grantvestmentId: grantvestment?.grantVestmentId as number,
                });
              }
            }}
            sx={{
              backgroundColor: "transparent",
              "&.Mui-disabled": {
                backgroundColor: "transparent",
                cursor: "not-allowed",
              },
            }}
            disabled={
              createGrantVestmentFollowerMutation.isLoading ||
              deleteGrantvestmentFollower.isLoading ||
              followerIsLoading
            }
          >
            <NotificationsIcon
              style={{
                fill: followState === true ? primary[500] : "transparent",
              }}
            />
          </IconButton>
          <IconButton
            className="grantvenstment"
            onClick={() => {
              if (likedState === true) {
                setLikedState(null);
                if (interactionData?.pages[0]?.data[0]) {
                  deleteGrantVestmentInteractionMutation.mutate(
                    interactionData.pages[0].data[0].interactionId
                  );
                }
              } else {
                setLikedState(true);
                createGrantVestmentInteractionMutation.mutate({
                  grantvestmentId: grantvestment?.grantVestmentId as number,
                  liked: true,
                  sub: user?.sub as string,
                });
              }
            }}
            sx={{
              backgroundColor: "transparent",
              "&.Mui-disabled": {
                backgroundColor: "transparent",
                cursor: "not-allowed",
              },
            }}
            disabled={
              createGrantVestmentInteractionMutation.isLoading ||
              deleteGrantVestmentInteractionMutation.isLoading ||
              isLoading
            }
          >
            <ThumbUpIcon
              style={{
                fill: likedState === true ? primary[500] : "transparent",
              }}
            />
          </IconButton>
          <IconButton
            className="grantvenstment"
            onClick={() => {
              if (likedState === false) {
                setLikedState(null);
                if (interactionData?.pages[0]?.data[0]) {
                  deleteGrantVestmentInteractionMutation.mutate(
                    interactionData.pages[0].data[0].interactionId
                  );
                }
              } else {
                setLikedState(false);
                createGrantVestmentInteractionMutation.mutate({
                  grantvestmentId: grantvestment?.grantVestmentId as number,
                  liked: false,
                  sub: user?.sub as string,
                });
              }
            }}
            sx={{
              backgroundColor: "transparent",
              "&.Mui-disabled": {
                backgroundColor: "transparent",
                cursor: "not-allowed",
              },
            }}
            disabled={
              createGrantVestmentInteractionMutation.isLoading ||
              deleteGrantVestmentInteractionMutation.isLoading ||
              isLoading
            }
          >
            <ThumbDownIcon
              style={{
                fill: likedState === false ? primary[500] : "transparent",
              }}
            />
          </IconButton>
        </>
      )}
    </>
  );
};

export default GrantVestmentInteractions;
